import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { createContext } from 'react';
import { useIntl } from 'react-intl';
import { FilterGroupOperator } from '../../types';
import { MessageType } from '../Messages';
import { FilterGroupRow } from './FilterGroupRow';
/**
 * Represents an empty filter group.
 */
const emptyGroup = {
    op: FilterGroupOperator.AND,
    conditions: [],
    groups: [],
};
/**
 * Context for the FilterBuilder component.
 */
export const FilterBuilderContext = createContext({
    criteria: { ...emptyGroup },
    clientId: 0,
    entityEnumType: {},
    onChange: () => { },
});
/**
 * A component for building filters.
 */
export const FilterBuilder = (props) => {
    const intl = useIntl();
    // only maintaining english content, and letting weglot handle the rest on the frontend
    const languages = ['en'];
    return (_jsxs(_Fragment, { children: [_jsx(FilterBuilderContext.Provider, { value: { ...props, languages }, children: _jsx(FilterGroupRow, { group: props.criteria, level: 1, onChange: item => props.onChange && props.onChange(item), onDelete: () => props.onError?.([
                        {
                            value: intl.formatMessage({ id: 'Root group cannot be deleted' }),
                            type: MessageType.ERROR,
                        },
                    ]), readonly: props.readonly, customizedMessaging: props.customizedMessaging }) }), props.debug && (_jsx("div", { className: 'bg-gray-100 p-3', children: _jsx("pre", { children: JSON.stringify(props.criteria, null, 3) }) }))] }));
};
